import { get, post, put, del } from 'utils/methods';

export function addNewProductGroupApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/product-group`, data, headers);
}

export function editProductGroupApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/product-group`, data, headers);
}

export function updateProductGroupTranslateApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/product-group/translate`, data, headers);
}

export function addCalculFormulaApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/product-group/calculation-formula`, data, headers);
}

export function getProductGroupsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}products-groups`, data, headers);
}

export function toggleProductGroupStatusApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/product-group/status`, data, headers);
}

export function attachPackagesToProductGroupApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/product-group/package`, data, headers);
}

export function detachPackagesToProductGroupApi(data, headers) {
    return del(`${process.env.REACT_APP_REST}commands/product-group/package`, data, headers);
}

export function updateSellPriceApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/product-group/sell-price`, data, headers);
}

export function toggleSellPriceStatus(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/sell-price/state`, data, headers);
}
